import Vue from 'vue'
import define from '../systemAdminDefineModules/systemAdminDefineMutation.js'
const URL = process.env.API_MASTER_URL
const header = define.state.header

export default {
  inputUpdate(store, payload) {
    store.commit('inputUpdate', payload)
  },
  inputAddUpdate(store, payload) {
    store.commit('inputAddUpdate', payload)
  },
  inputAddUpdateAdminUser(store, payload) {
    store.commit('inputAddUpdateAdminUser', payload)
  },
  inputUpdateAdminUser(store, payload) {
    store.commit('inputUpdateAdminUser', payload)
  },
  clearCorporation(store) {
    store.commit('clearCorporation')
  },
  setFlags(store, corporationFlags) {
    store.commit('setFlags', corporationFlags)
  },
  setConstractDateTime(store, constractDate) {
    store.commit('setConstractDateTime', constractDate)
  },
  assignFromAddToDetail(store) {
    store.commit('assignFromAddToDetail')
  },
  checkedPostsAction(store, payload) {
    store.commit('reversedPostsCheck', payload)
  },
  checkedUsersAction(store, payload) {
    store.commit('reversedUsersCheck', payload)
  },
  clearUserAndPostCheck(store) {
    store.commit('clearUserAndPostCheck')
  },
  setCallAppList(store, callAppList) {
    store.commit('setCallAppList', callAppList)
  },
  async addCorporation(store) {
    store.state.corporations = []
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: store.state.addCorporation
    }
    await Vue.http.post(URL + '/v2/master/corporation/regist', data, config)
  },
  async setCorporations(store, payload) {
    store.state.corporations = []
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        pageNo: payload.pageNo,
        count: 20,
        searchWord: payload.searchWord
      }
    }
    var response = await Vue.http.post(
      URL + '/v2/master/corporation/list',
      data,
      config
    )
    // 成功
    store.commit('setCorporations', response)
  },
  async updateCorporation(store) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: store.state.updateCorporation
    }
    await Vue.http.post(URL + '/v2/master/corporation/update', data, config)
  },
  async deleteCorporations(store, payload) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        companyId: payload
      }
    }
    var response = await Vue.http.post(
      URL + '/v2/master/corporation/delete',
      data,
      config
    )
    // 成功
    // 削除後の処理
    store.commit('setDevices', response)
  },
  async setDetailCorporation(store, payload) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        companyId: payload
      }
    }
    var response = await Vue.http.post(
      URL + '/v2/master/corporation/detail',
      data,
      config
    )
    // 成功
    store.commit('setDetail', response)
  },
  async setRatesInfos(store, payload) {
    payload.rateConditions[0]['userId'] = header.userId
    let logContinue = true
    let pageNo = 0
    const count = 1000
    const margeData = {
      data: {
        header: {},
        data: [
          {
            title: {},
            values: []
          }
        ]
      }
    }
    while (logContinue) {
      const config = {
        headers: {
          Authorization: define.state.authorization
        },
        timeout: 1000 * 300
      }
      const data = {
        header,
        data: [
          {
            tenantKey: payload.tenantKey,
            rateConditions: payload.rateConditions,
            pageNo: pageNo,
            count: count
          }
        ]
      }
      var response = await Vue.http.post(
        URL + '/v2/master/rate/summary',
        data,
        config
      )

      const size = response.data.data[0]['values'].length
      for (let i = 0; i < size; i++) {
        margeData.data.data[0].values.push(response.data.data[0]['values'][i])
      }
      pageNo++
      if (size < count) {
        margeData.data.header = response.data['header']
        margeData.data.data[0].title = response.data.data[0]['title']
        logContinue = false
      }
    }

    // 成功
    store.commit('setRatesInfos', margeData)
  },
  async setRateLogInfos(store, payload) {
    let logContinue = true
    let pageNo = 0
    const count = 1000
    const margeData = {
      data: {
        header: {},
        data: [
          {
            title: {},
            values: []
          }
        ]
      }
    }
    while (logContinue) {
      const config = {
        headers: {
          Authorization: define.state.authorization
        },
        timeout: 1000 * 300
      }
      const data = {
        header,
        data: [
          {
            tenantKey: payload.tenantKey,
            rateConditions: payload.rateConditions,
            pageNo: pageNo,
            count: count
          }
        ]
      }
      var response = await Vue.http.post(
        URL + '/v2/master/rate/export',
        data,
        config
      )

      const size = response.data.data[0]['values'].length
      for (let i = 0; i < size; i++) {
        margeData.data.data[0].values.push(response.data.data[0]['values'][i])
      }
      pageNo++
      if (size < count) {
        margeData.data.header = response.data['header']
        margeData.data.data[0].title = response.data.data[0]['title']
        logContinue = false
      }
    }

    // 成功
    store.commit('setRateLogInfos', margeData)
  },
  async setLocationLogInfos(store, payload) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          locationLogConditions: payload
        }
      ]
    }
    var response = await Vue.http.post(URL + '/Locations/Logs', data, config)
    // 成功
    store.commit('setLocationLogInfos', response)
  },
  async setUserInfos(store, payload) {
    store.state.users = []
    store.state.posts = []
    let logContinue = true
    let pageNo = 0
    const count = 500
    const margeData = {
      data: {
        header: {},
        data: []
      }
    }
    while (logContinue) {
      const config = {
        headers: {
          Authorization: define.state.authorization
        },
        timeout: 1000 * 300
      }
      const data = {
        header,
        data: [
          {
            tenantKey: payload,
            pageNo: pageNo,
            count: count
          }
        ]
      }
      var response = await Vue.http.post(
        URL + '/v2/master/user/list',
        data,
        config
      )

      const size = response.data['data'].length
      for (let i = 0; i < size; i++) {
        margeData.data.data.push(response.data['data'][i])
      }
      pageNo++
      if (size < count) {
        margeData.data.header = response.data['header']
        logContinue = false
      }
    }

    // 成功
    store.commit('setUserInfos', margeData)
  },
  async setPostInfos(store, payload) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          tenantKey: payload
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/master/post/list',
      data,
      config
    )
    // 成功
    store.commit('setPostInfos', response)
  },
  async setCallAppDefine(store, payload) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          companyId: payload
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/master/callapp/list',
      data,
      config
    )
    // 成功
    store.commit('setCallAppDefine', response)
  },
  async setUsageLogs(store, payload) {
    let logContinue = true
    let count = 0
    const margeData = {
      data: {
        header: {},
        data: [
          {
            title: [],
            values: []
          }
        ]
      }
    }
    const exportData = []
    const date = new Date(payload.targetMonth)
    const startDateTime = new Date(
      date.getFullYear(),
      date.getMonth(),
      1,
      0,
      0,
      0
    )
    const endDateTime = new Date(
      date.getFullYear(),
      date.getMonth() + 1,
      0,
      23,
      59,
      59,
      999
    )
    while (logContinue) {
      const config = {
        headers: {
          Authorization: define.state.authorization
        },
        timeout: 1000 * 300
      }
      const data = {
        header,
        data: {
          type: payload.type,
          count: count,
          startDateTime: startDateTime.getTime(),
          endDateTime: endDateTime.getTime(),
          tenantKey: payload.tenantKey
        }
      }
      var response = await Vue.http.post(
        URL + '/v2/master/usagelog/export',
        data,
        config
      )

      exportData.push(...response.data.data[0]['values'])
      count = exportData.length
      if (!response.data['remain']) {
        margeData.data.header = response.data['header']
        margeData.data.data[0].title = response.data.data[0]['title']
        margeData.data.data[0].values = exportData
        logContinue = false
      }
    }

    // 成功
    switch (payload.type) {
      case 0:
        store.commit('setUsageLogsAuditLog', margeData)
        break
      case 1:
        store.commit('setUsageLogsCallHistory', margeData)
        break
      default:
        // 0,1以外は処理しない
        break
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/systemAdminModules/companiesModules/actions.js